import {useMutation} from '@tanstack/react-query';
import {BackendResponse} from '../../http/backend-response/backend-response';
import {useNavigate} from '../../utils/hooks/use-navigate';
import {apiClient, queryClient} from '../../http/query-client';
import {showHttpErrorToast} from '../../utils/http/show-http-error-toast';
import {useAppearanceEditorMode} from '../../admin/appearance/commands/use-appearance-editor-mode';
import {message} from '../../i18n/message';
import {useBootstrapData} from '../../core/bootstrap-data/bootstrap-data-context';

interface Response extends BackendResponse {
  bootstrapData: string;
}

const appearanceMessage = "Can't logout while in appearance editor.";

export function useLogout() {
  const navigate = useNavigate();
  const {isAppearanceEditorActive} = useAppearanceEditorMode();
  const {setBootstrapData} = useBootstrapData();
  return useMutation({
    mutationFn: () => (isAppearanceEditorActive ? noopLogout() : logout()),
    onSuccess: async response => {
      // Clear query client first
      queryClient.clear();
      
      // Clear Deepsite authentication cookie
      document.cookie = 'builditai-auth-token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=.smsit.ai';
      
      // Delete the session from the database to invalidate Deepsite access
      try {
        await apiClient.post('auth/delete-session');
      } catch (error) {
        console.error('Failed to delete session:', error);
      }
      
      // Use window.location.replace to force external navigation and prevent router interception
      window.location.replace('https://aicpanel.smsit.ai/logout');
    },
    onError: err =>
      showHttpErrorToast(
        err,
        isAppearanceEditorActive ? message(appearanceMessage) : undefined,
      ),
  });
}

function logout(): Promise<Response> {
  return apiClient.post('auth/logout').then(r => r.data);
}

function noopLogout() {
  return Promise.reject(appearanceMessage);
}
